import { FC, useEffect } from 'react'
import { processEnv } from '@util/react-env'

const AdobeInitiator: FC = () => {
  const url = processEnv().ADOBE_ANALYTIC_URL
  useEffect(() => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [url])
  return null
}

export default AdobeInitiator
